import * as React from 'react';

const SvgIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
    <path
      fill="#0044F0"
      d="M35 29a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2zM35 19a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2zM35 9a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2z"
    ></path>
  </svg>
);

export default SvgIcon;
